import { sanityClient } from './client'

// The embedded Studio (same origin, /studio) persists its session under this
// key when it can't use cookie auth (any non-*.sanity.studio host).
// Mirrors sanity's `getAuthTokenStorageKey` — grep AUTH_TOKEN_STORAGE_PREFIX
// in the sanity package if a Studio upgrade breaks preview.
const STORAGE_KEY = `__studio_auth_token_${import.meta.env.VITE_SANITY_PROJECT_ID as string}`

export function studioToken(
  storage: Pick<Storage, 'getItem'> = localStorage,
): string | undefined {
  try {
    const token = JSON.parse(storage.getItem(STORAGE_KEY) ?? 'null')?.token
    return typeof token === 'string' ? token : undefined
  } catch {
    return undefined
  }
}

// Draft-reading client authenticated as the *editor* (their own Studio
// session), so Sanity itself enforces project membership: no site-side auth,
// no shared server token. `withCredentials` is the cookie-auth fallback.
export const previewClient = (token: string | undefined) =>
  sanityClient.withConfig({
    token,
    withCredentials: !token,
    useCdn: false,
    perspective: 'drafts',
    ignoreBrowserTokenWarning: true,
  })
